import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { TransactionStatusEnum } from "@bitwarden/web-vault/app/models/enum/transactionType";

// Balance-tracking rows (opening/closing/alignment/etc.) always carry an explicit, non-"transaction"
// definition. Legacy records synced before `definition` existed can have it undefined — treat those
// as real transactions too rather than silently dropping them.
export function isRealTransaction(tx: TransactionView): boolean {
  return tx.definition === TransactionStatusEnum.transaction || tx.definition == null;
}

export function getSafeAmount(tx: TransactionView): number {
  let raw = 0;
  if (tx.quantity?.actualQuantity?.amount != null) {
    raw = parseFloat(String(tx.quantity.actualQuantity.amount));
  } else if (tx.c_valuation?.value?.amount != null) {
    raw = parseFloat(String(tx.c_valuation.value.amount));
  }
  return isNaN(raw) ? 0 : raw;
}

export function getSafeSymbol(tx: TransactionView): string {
  return tx.quantity?.actualQuantity?.symbol || tx.quantity?.currency || "";
}

export function getDateString(tx: TransactionView): string {
  if (tx.glossPostDate?.dateString) {
    return tx.glossPostDate.dateString;
  }
  if (tx.postDate) {
    return new Date(tx.postDate).toISOString().slice(0, 10);
  }
  return "N/A";
}

export function formatAbsAmount(value: number): string {
  return Math.abs(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// Strips trailing reference codes common in card statements:
//   NETFLIX*123456  →  netflix
//   STORE #1234     →  store
//   MERCHANT 12345678 →  merchant
// Order matters: strip numeric suffix first so "*WORD 123456" and "*WORD" both reduce to the same key.
export function normalizeDescription(desc: string | null | undefined): string {
  if (!desc) {
    return "unknown";
  }
  return (
    desc
      .trim()
      .replace(/\s+\d{6,}$/, "")
      .replace(/\*[A-Za-z0-9]*$/, "")
      .replace(/\s*#\s*\d+$/, "")
      .trim()
      .toLowerCase() || "unknown"
  );
}
